import React from 'react';
import { useApp } from '../context/AppContext';
import './Expired.css';

const PHONE = '5493487331058';
const EMAIL = 'mariarosapoggi@gmail.com';

function monthName(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
}

export default function Expired() {
  const { user, logout } = useApp();

  const month = user?.subscriptionEnd ? monthName(user.subscriptionEnd) : '';

  function openWhatsApp() {
    const msg = encodeURIComponent('Hola María Rosa, quiero renovar mi suscripción a Gimnasia Consciente.');
    window.open(`https://wa.me/${PHONE}?text=${msg}`, '_blank');
  }

  function openEmail() {
    window.location.href = `mailto:${EMAIL}?subject=Renovar%20Suscripci%C3%B3n&body=Hola%20Mar%C3%ADa%20Rosa%2C%20quiero%20renovar%20mi%20suscripci%C3%B3n%20a%20Gimnasia%20Consciente.`;
  }

  return (
    <div className="expired-screen">
      <div className="expired-top">
        <div className="expired-eyebrow">Gimnasia Consciente</div>
        <div className="expired-icon">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="20" stroke="#C8BFAF" strokeWidth="0.8" />
            <circle cx="24" cy="24" r="12" stroke="#C8BFAF" strokeWidth="0.8" />
            <line x1="24" y1="14" x2="24" y2="24" stroke="#8B7355" strokeWidth="1" strokeLinecap="round" />
            <line x1="24" y1="24" x2="30" y2="28" stroke="#8B7355" strokeWidth="1" strokeLinecap="round" />
          </svg>
        </div>
      </div>

      <div className="expired-body">
        <h2 className="expired-title">
          Su suscripción{month ? ` del mes de ${month}` : ''} ha finalizado
        </h2>
        <p className="expired-text">
          Para continuar escuchando las clases, por favor renueve su suscripción.
          Puede hacerlo contactándonos por WhatsApp o email.
        </p>
      </div>

      <div className="expired-actions">
        <button className="expired-btn expired-btn-wa" onClick={openWhatsApp}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9c0 1.32.345 2.565.945 3.645L1.5 16.5l3.99-1.02A7.44 7.44 0 009 16.5c4.14 0 7.5-3.36 7.5-7.5S13.14 1.5 9 1.5z" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" fill="none"/>
            <path d="M6.75 6.375c.15.33 1.005 1.875 1.095 2.01.09.135.09.255 0 .39-.09.135-.135.21-.27.33-.135.12-.285.27-.405.36-.12.09-.255.195-.105.435.15.24.66 1.095 1.41 1.77.975.87 1.77 1.155 2.01 1.275.24.12.375.105.525-.06.15-.165.615-.72.78-.96.165-.24.33-.195.555-.12.225.075 1.425.675 1.665.795.24.12.4.18.46.285.06.105.06.6-.15 1.185-.21.585-1.2 1.11-1.695 1.155-.495.045-.51.36-3.225-.75-3.24-1.32-5.13-4.65-5.28-4.86-.15-.21-1.2-1.59-1.2-3.03s.765-2.145.99-2.385c.225-.24.465-.3.63-.3l.45.015z" fill="currentColor"/>
          </svg>
          Renovar por WhatsApp
        </button>

        <button className="expired-btn expired-btn-email" onClick={openEmail}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <rect x="2" y="4" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1" />
            <path d="M2 6l7 5 7-5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
          </svg>
          Renovar por Email
        </button>
      </div>

      <button className="expired-logout" onClick={logout}>Cerrar sesión</button>
    </div>
  );
}
